import React, { useEffect } from 'react';
import ListingFilters from './components/filters';
import { AdvertList } from './components/list';
import { AdvancedFilterButton } from 'components/common/advanced-filter-button';
import { useMobileTab } from 'hooks/use-mobile-tab';

const AdvertListingPage = () => {
    const { onTabChange } = useMobileTab();

    useEffect(() => {
        onTabChange('search');
    }, []);

    return (
        <div>
            <div className="absolute top-0 left-0 w-full h-[900px] bg-home-small md:bg-home" />
            <ListingFilters />
            <div className=" w-full md:px-0 md:w-[925px] lg:w-[1240px] mx-auto z-[1] relative">
                <AdvertList />
            </div>
            <AdvancedFilterButton />
        </div>
    );
};

export default AdvertListingPage;
